<template>
  <div>
    <div v-for="option in localOptions" :key="option.id" class="row option-box py-3">
      <div class="col--5 m-2 pt-2">
        {{ option.name }}
      </div>
      <div class="col--3">
        <input type="text" class="form-control form-control--text numeric-input EnterToTab" :value="option.text"
               :readonly="viewMode" :maxlength="maxLength" v-enter-to-tab
               @blur="onBlur()" @change="valueChange(option, $event)" @focus="selectAll($event)" />
      </div>
      <div class="col">
        <app-select :disabled="viewMode" enterToTab :options="option.types" :initial-value="option.selectedType"
                    @onSelected="onTypeSelected(option, $event)" />
      </div>
    </div>
    <div v-if="showAutosaveInfo" class="autosave-info mt-3">
      {{ $t('question.numericVariableList.autosaveInfo')}}
    </div>
  </div>
</template>

<script>
import AppSelect from '@/components/AppSelect';
import getEnv from '../../../utils/env';

export default {
  components: { AppSelect },
  name: "NumericVariableList",
  'comments': { AppSelect },
  'props': {
    'questionId': 0,
    'questionOptions': Array,
    'viewMode': {
      'type': Boolean,
      'required': false
    },
    'maxLength': null,
  },
  data() {
    return {
      // It holds all the options of the question but formatted to separate the question from the variable options
      localOptions: [],
      showAutosaveInfo: false,
    }
  },
  'methods': {
    valueChange(option, e) {
      const regexNumerico = /^\d+$/
      let element = e.target

      if (regexNumerico.test(element.value)) {
        element.value = element.value.slice(0, this.maxLength ?? 20);
      } else {
        element.value = '0'
        e.preventDefault()
      }

      option.text = element.value
    },
    onBlur() {
      if (this.viewMode) {
        return;
      }

      this.answerQuestion();
    },
    selectAll(event) {
      event.target.select();
    },
    onTypeSelected(option, value) {
      option.selectedType = value;
      this.answerQuestion();
    },
    answerQuestion() {
      // Check if all fields are completed before saving
      const isIncomplete = this.localOptions.some((field) => { return !field.selectedType || !field.text })

      if (isIncomplete) {
        return 
      }

      // Before sending the answer, we format the questions to send to the server
      const response = this.localOptions.map((option) => {
        return {
          ...option,
          text: option.selectedType ? `${option.text};${option.selectedType}` : option.text,
        }
      });

      this.$emit('onAnswered', response);
    },
    formatQuestions() {
      this.localOptions = this.questionOptions.map((option) => {
        const [text, selectedType] = option.text.split(';');
        const [name, typeValues] = option.name.split(';');
        const types = typeValues.split(':').map((type) => {
          return {
            'value': type,
            'text': type,
          }
        });

        return {
          ...option,
          name: name,
          text: !option.text ? '0' : text,
          types: types,
          selectedType: selectedType,
        }
      });
    }
  },
  created() {
    this.formatQuestions();

    // Mostrar un mensaje de "se guarda cuando se complete"
    if (getEnv('VUE_APP_ENABLE_AUTOSAVE')?.toLowerCase() === 'true') {
      this.showAutosaveInfo = true
    }
  },
}
</script>

<style scoped>
.option-box {
  border-top: solid 2px #E3E3E3;
  border-bottom: solid 2px #E3E3E3;
}

.option-box + .option-box {
  border-top: none;
}

.option-box:nth-child(odd) {
  background-color: #FAFAFA;
}

.numeric-input {
  padding-right: 0.4rem;
  padding-left: 0.4rem;
  height: 36px !important;
  font-size: 1rem !important;
}

.form-control {
  box-shadow: none;
  background-color: rgb(255, 255, 255);
  height: 40px;
  font-size: 0.875rem;
  line-height: 1.5rem;
  flex: 1 1 auto;
  border: 1px solid rgb(76, 77, 87);
}

.autosave-info {
  font-size: 10px;
  opacity: 0.8;
  font-style: italic;
  line-height: 1;
}

</style>